export default {
  changeMenu(context) {      
    context.commit('changeMenu')
  },
  async updateMenu( context) {
    //await dispatch('loadPosts','proyectos');
    //let proyectos = this.$store.getters[`wordpress/getProyectos`];
    
    let proyectos = context.rootState.wordpress.proyectos;

    let proyectosOrdenados = proyectos.sort(function (a, b) {
      if (a.orden > b.orden) {
          return -1;
      }
      if (a.orden < b.orden) {
          return 1;
      }
      // a must be equal to b
      return 0;
      });
  
    //console.log(proyectos)
    context.commit('updateMenuMut', proyectosOrdenados)        
  },
  handleVisibility(context) {
    context.commit('handleVisibility')
  },
  handleOrientation(context) {
    context.commit('handleOrientation')
  },
  closeMenu(context) {
    context.commit('closeMenu')
  },
  changeScroll(context, payload) {     
    context.commit('changeScroll', payload.scroll)
  },
}